<form [formGroup]="form" class="provider-form" (ngSubmit)="submit()">
  <h1>Formulario para creación de proveedor</h1>
  <div class="control">
    <input
      class="input"
      type="text"
      placeholder="Ingrese nombre del proveedor"
      formControlName="name"
    />
    <p class="error-message" [class.active]="name.touched && name.invalid">
      @if (name.touched && name.hasError("required")) {
        Este campo es requerido
      }
    </p>
  </div>
  <div class="control">
    <input
      class="input"
      type="text"
      placeholder="Ingrese Nit del proveedor"
      formControlName="nit"
    />
    <p class="error-message" [class.active]="nit.touched && nit.invalid">
      @if (nit.touched && nit.hasError("required")) {
        Este campo es requerido
      }
      @if (nit.touched && nit.hasError("pattern")) {
        El formato del NIT es inválido
      }
    </p>
  </div>
  <div class="control">
    <input
      class="input"
      type="text"
      placeholder="Ingrese email del proveedor"
      formControlName="email"
    />
    <p class="error-message" [class.active]="email.touched && email.invalid">
      @if (email.touched && email.hasError("required")) {
        Este campo es requerido
      }
      @if (email.touched && email.hasError("email")) {
        El formato del email es inválido
      }
    </p>
  </div>
  <div class="checkboxList">
    <h3>Seleccione los tipos de notificación</h3>
    <div formArrayName="notificationTypes">
      @for (item of types; track $index) {
        <label>
          <input
            class="checkbox"
            type="checkbox"
            [value]="item.id"
            (change)="onCheckboxChange($event)"
            [formControlName]="$index"
          />
          {{ item.label }}
        </label>
      }
    </div>
    <p
      class="error-message"
      [class.active]="notificationTypes.touched && notificationTypes.invalid"
    >
      @if (notificationTypes.invalid && notificationTypes.touched) {
        Debe seleccionar al menos un tipo de notificación
      }
    </p>
  </div>

  <app-button
    label="Crear proveedor"
    variant="primary"
    type="submit"
    [disabled]="form.invalid"
  ></app-button>
</form>
